import React from 'react';
import { PageHeader } from '@/ui/PageHeader';
import { NotesBoard, type NotesBoardMetaField } from '@/components/NotesBoard';

const STATUS_OPTIONS = ['idea', 'testing', 'working', 'core', 'dead'];

const META_FIELDS: NotesBoardMetaField[] = [
  {
    key: 'usertype',
    label: 'User type',
    placeholder: 'e.g. Greek life',
    suggestions: [
      '21+ upperclassmen',
      'Freshmen & sophomores',
      'Greek life',
      'Grad students',
      'Bar regulars',
      'Occasional night-outers',
      'Game-day / visitors',
      'Bartenders & staff',
      'Venue owners',
    ],
  },
  {
    key: 'kind',
    label: 'What it is',
    placeholder: 'e.g. marketing message',
    suggestions: [
      'persona profile',
      'marketing message',
      'channel play',
      'hook',
      'offer / incentive',
      'experiment',
      'insight',
    ],
  },
];

export function MarketingScreen() {
  return (
    <div className="admin-page max-w-3xl mx-auto">
      <PageHeader
        title="Marketing"
        subtitle="The strategy HQ — a map of user types. Under each type: who they are, the messages that land with them, and the plays for reaching them. Studios and content sessions pull from here."
      />
      <NotesBoard
        page="marketing"
        statusOptions={STATUS_OPTIONS}
        metadataFields={META_FIELDS}
        groupByField="usertype"
        newButtonLabel="Add to the map"
        emptyTitle="The map is empty"
        emptyHint='Start each user type with a "persona profile" note (who they are, where they hang out, what they care about), then stack targeting strategies and messages under it. Promote what works to "core".'
      />
    </div>
  );
}
